import { customElement } from 'lit/decorators.js'
import { BoardViewerPage } from './board-viewer-page'

@customElement('app-board-viewer-page')
export class AppBoardViewerPage extends BoardViewerPage {
  get context() {
    return {
      title: super.context.title
    } as any
  }
}
